import {
   URL_CORE_PRICING_SAVE_CRITERIA_CONTEXT_ID,
   URL_SAVE_CRITERIA_CONTEXT_ID,
   URL_CORE_PRICING_DISTRIBUTION_SCREEN_SAVE_CRITERIA_CONTEXT_ID,
   URL_CORE_PRICING_FOOTNOTES_SCREEN_SAVE_CRITERIA_CONTEXT_ID,
   URL_CORE_PRICING_RULES_SCREEN_SAVE_CRITERIA_CONTEXT_ID,
} from './utils/constants.js';

const URL_HEP = 'api/configuration/hep?type=';

export const URL_SAVE_CRITERIA = 'api/usersearch';

export const URL_NEW_DISTRIBUTION_GROUP_GENERATE =
   'api/distribution/distributiongroup/generate/I';

export const URL_NEW_DISTRIBUTION_GROUP_SEARCH =
   'api/distribution/distributiongroup/search';

export const URL_DISTRIBUTION_GROUP_APPROVED =
   'api/distribution/distributiongroup/approve';

export const URL_DELETE_BULK = 'api/usersearch/bulk';

export const URL_LOAD_TIME = 'api/external/corepricing/loadtime';

export const URL_SAVE_CRITERIA_FILTER_OF_CONTEXT_ID = `?filter=contextId=='${URL_SAVE_CRITERIA_CONTEXT_ID}`;

export const URL_CORE_PRICING_SAVE_CRITERIA_FILTER_OF_CONTEXT_ID = `?filter=contextId=='${URL_CORE_PRICING_SAVE_CRITERIA_CONTEXT_ID}`;

export const URL_CORE_PRICING_DISTRIBUTION_SCREEN_SAVE_CRITERIA_FILTER_OF_CONTEXT_ID = `?filter=contextId=='${URL_CORE_PRICING_DISTRIBUTION_SCREEN_SAVE_CRITERIA_CONTEXT_ID}`;

export const URL_CORE_PRICING_FOOTNOTES_SCREEN_SAVE_CRITERIA_FILTER_OF_CONTEXT_ID = `?filter=contextId=='${URL_CORE_PRICING_FOOTNOTES_SCREEN_SAVE_CRITERIA_CONTEXT_ID}`;

export const URL_CORE_PRICING_RULES_SCREEN_SAVE_CRITERIA_FILTER_OF_CONTEXT_ID = `?filter=contextId=='${URL_CORE_PRICING_RULES_SCREEN_SAVE_CRITERIA_CONTEXT_ID}`;

export const URL_SAVE_CRITERIA_FILTER_OF_USER_ID = ';userId==';

export const URL_RECOMM_SUMMARY_FLATTENED =
   'api/external/faresoptimizer/recommendationsummary/search';

export const URL_FARE_CHANGES_SUMMARY_MONGO_FLATTENED =
   'api/external/faresoptimizer/farechangessummary/search';

export const URL_FARE_CHANGES_SUMMARY_ATHENA_FLATTENED =
   'api/external/faresoptimizer/farechangessummary/athenasearch';

export const URL_HEP_ANALYST_POS_MAPPING = `${URL_HEP}FOAnalystPosMapping`;

export const URL_CORE_PRICING_SEARCH = '/api/external/corepricing/search';

export const URL_DYNAMIC_RESOLUTION = '/api/v1/resolvefares';

export const URL_CONSTRUCTED_FARES = '/api/v1/constructedFares';

export const URL_CORE_PRICING_NEW_FARES_SAVE =
   '/api/corepricing/workingfares/create/I';

export const URL_CORE_PRICING_WORKING_FARES = '/api/corepricing/workingfares/I';

export const URL_CORE_PRICING_DELETE_DISTRIBUTION =
   'api/distribution/distributiongroup/I';

export const URL_CORE_PRICING_SAVE_DISTRIBUTION =
   'api/distribution/distributiongroup';

export const URL_CORE_PRICING_FOOTNOTES = '/api/v1/search/rules-footnotes';

export const URL_CORE_PRICING_DISTRIBUTION_FILE_UPLOAD =
   '/api/corepricing/workingfares/file/I';

export const URL_CORE_PRICING_MARKET_LIST_SEARCH =
   '/api/corepricing/marketlist/search';

export const URL_CORE_PRICING_MARKET_LIST_SAVE =
   '/api/corepricing/marketlist/create';

export const URL_CORE_PRICING_MARKET_LIST_DELETE =
   '/api/corepricing/marketlist';

export const URL_CORE_PRICING_MARKET_LIST_FILE_UPLOAD =
   '/api/corepricing/file/upload';
